"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AdmissionAreaSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M14,3 C14.5522847,3 15,3.44771525 15,4 L15,14 C15,14.5522847 14.5522847,15 14,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,4 C3,3.44771525 3.44771525,3 4,3 L14,3 Z M14,4 L4,4 L4,14 L14,14 L14,4 Z M9.41892801,5.22605965 L9.46153846,5.30769231 L11.9615385,11.3076923 C12.0677471,11.562593 11.9472083,11.8553299 11.6923077,11.9615385 C11.4657293,12.0559461 11.2092557,11.9711954 11.0804651,11.7721715 L11.0384615,11.6923077 L10.333,10 L7.666,10 L6.96153846,11.6923077 C6.86713081,11.9188861 6.62534279,12.0393019 6.39375276,11.98867 L6.30769231,11.9615385 C6.08111395,11.8671308 5.9606981,11.6253428 6.01132999,11.3937528 L6.03846154,11.3076923 L8.53846154,5.30769231 C8.6971917,4.92673993 9.20966335,4.89952904 9.41892801,5.22605965 Z M9,6.8 L8.083,9 L9.917,9 L9,6.8 Z" })));
};
AdmissionAreaSmall.displayName = 'AdmissionAreaSmall';
exports.default = AdmissionAreaSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AdmissionAreaSmall.js.map